<template>
  <div>
    <div class="row">
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card card-primary">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{period}}</h4>
                <p style="font-size: 12px">{{current_datetime}}h</p>
              </div>
              <div class="hidden-xs-down col-md-2" style="text-align: right">
                <i class="fa fa-clock-o fa-4x"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card card-primary">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{Math.round(pot_contracted*100)/100}} kW</h4>
                <p style="font-size: 12px">{{web_texts.partials.pot_contracted}}</p>
              </div>
              <div class="hidden-xs-down col-md-2" style="text-align: right">
                <i class="fa fa-flash fa-4x"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card card-warning">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{Math.round((pot_contracted*100 * 1.05))/100}} kW</h4>
                <p style="font-size: 12px">{{web_texts.partials.pot_penalty}}</p>
              </div>
              <div class="col-md-2 hidden-xs-down" style="text-align: right">
                <i class="fa fa-warning fa-4x card-icon"></i>
              </div>
            </div>
          </div>
          <div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card" :class="class_card_color"><!--:class="class_card_color"-->
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{api_general}} kW</h4>
                <p style="font-size: 12px">{{web_texts.partials.current_power}}</p>
              </div>
              <div class="col-md-2 hidden-xs-down" style="text-align: right">
                <i class="fa fa-plug fa-4x card-icon"></i>
              </div>
            </div>
          </div>
          <div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
        <div class="card">
          <div class="card-header">
            <span>Estat SCE</span>
          </div>
          <div class="card-block">
            <canvas id="status-home-analyzer" style="height: 300px; width: 100%;"></canvas>
          </div>
          <div class="card-footer">
            <ul>
              <li>
                <div class="text-muted">{{web_texts.partials.status}}</div>
                <strong>{{status_analyzer}}</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
        <div class="card">
          <div class="card-header">
            <span>{{web_texts.partials.current_active_power}}</span>
          </div>
          <div class="card-block">
<!--            <canvas id="active-power-general" style="height: 295px; width: 100%;"></canvas>-->
            <div id="active-power-general" style="height: 295px; width: 100%;"></div>
          </div>
          <div class="card-footer">
            <ul>
              <li>
                <div class="text-muted">{{web_texts.partials.current_active_power}}</div>
                <strong>{{api_general}} kW</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
        <div class="card">
          <div class="card-header">
            <span>{{web_texts.partials.historical_active_power_diary}}</span>
          </div>
          <div class="card-block">
            <div id="active-power-general-diari" style="height: 295px; width: 100%;"></div>
          </div>
          <div class="card-footer">
            <ul>
              <li>
                <div class="text-muted">{{web_texts.partials.current_active_power}}</div>
                <strong>{{api_general}} kW</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
        <div class="card">
          <div class="card-header">
            <span>{{web_texts.partials.cos_phi_2}}</span>
          </div>
          <div class="card-block">
<!--            <canvas id="cosi-general" style="height: 295px; width: 100%;"></canvas>-->
            <div id="cosi-general" style="height: 295px; width: 100%;"></div>
          </div>
          <div class="card-footer">
            <ul>
              <li>
                <div class="text-muted">{{web_texts.partials.cos_phi}}</div>
                <strong>{{cosi_general}} φ</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="card">
          <div class="card-header">
            <span>{{web_texts.partials.monthly_energy_consumed}}</span>
          </div>
          <div class="card-block">
            <div id="ener-act-hom-analyzer" style="height: 300px; width: 100%;"></div>
          </div>
        </div>
      </div>
    </div>

    <!--<div class="row">-->
      <!--<div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">-->
        <!--<div class="card">-->
          <!--<div class="card-header">-->
            <!--<span>Ubicació del Sistema</span>-->
          <!--</div>-->
          <!--<div class="card-block">-->
            <!--<gmap-map id="map" :center="{lat:parseFloat(system_coordinates.split('#')[0]), lng:parseFloat(system_coordinates.split('#')[1])}" :zoom="18" map-type-id="hybrid">-->
              <!--<gmap-marker-->
                <!--:position="{lat:parseFloat(system_coordinates.split('#')[0]), lng:parseFloat(system_coordinates.split('#')[1])}">-->
              <!--</gmap-marker>-->
            <!--</gmap-map>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
  </div>
</template>

<script>
  import trans_cat from '../../../translates/cat/Home';
  import trans_es from '../../../translates/es/Home';
  import constants from '../../../constants';
  import middleware from '../../../utilities/middlewares';
  import dateRanges from '../../../utilities/dates_intervals';
  import dataTransforms from '../../../utilities/data_transformers';

  export default {
    name: '',
    props: ['devices', 'master_dev'],
    data() {
      return {
        web_texts: { "electric_params": "Paràmetres Elèctrics", "generator": "Grup Electrogen", "pump_well": "Bomba-Bassa", "partials": {"historical_active_power_diary": "Històric diari potència activa","cos_phi_2": "Cosinus de phi φ", "pot_contracted": "Pot. Contractada", "pot_penalty": "Pot. Penalització", "current_power": "Pot. Actual", "status": "Estat", "current_active_power": "Potència Activa Instantània", "cos_phi": "Cosinus de Phi Instantani", "monthly_energy_consumed": "Històric anual d'energia consumida", "generator_status": "Estat Grup", "api_general": "Pot. General", "api_generator": "Pot. Grup", "current_tension": "Tensió actual", "active_power": "Potència activa", "active_power_now": "Potència Activa Instantània", "active_reactive_energy": "Energia activa reactiva", "Cos_phi": "Cosinus de phi", "monthly_active_power": "Històric potencia activa mensual", "pump_status": "Estat Bomba", "flow_pump": "Cabal Bomba", "counter_lecture": "Lec. Comptador", "vol_raft": "Niv. Bassa", "historical_pump_activations": "Històric activacions bomba", "historical_low_level": "Històric nivell bassa" } },
        period: 'S/D',
        general: '',
        current_datetime: 'S/D',
        pot_contracted: 'S/D',
        class_card_color: 'card-success',
        cosi_general: 'S/D',
        api_general: 'S/D',
        ae_general: 'S/D',
        ie_general: 'S/D',
        mdapi_general: 'S/D',
        system_coordinates:'',
        status_analyzer: 'S/D',
        status_show_server: 'S/D',
        status_show_eds: 'S/D',
        status_show_analyzer: 'S/D'
      }
    },
    created() {
      console.log("Created Analizer");
      middleware.userIsLoged();
      window.localStorage.setItem('real_time_control', '["home","analyzer"]');
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);

      var out = this;
      this.system = JSON.parse(window.localStorage.getItem('system'));
      this.system_coordinates=this.system.coordinates;
      this.current_datetime = dateRanges.getCurrentDateTime();
      this.getHeadCardsInfo();

      var general_interval = setInterval(function () {
        console.log("Interval Analizer");
        var contr_rt = JSON.parse(window.localStorage.getItem('real_time_control'));

        if (contr_rt[1] !== "analyzer") {
          console.log("Clear analizer loop");
          clearInterval(general_interval);
        } else {
          out.current_datetime = dateRanges.getCurrentDateTime();
          out.getRealTimeValues();
          out.getHeadCardsInfo();
        }
      }, 5000);

    },
    mounted() {
      this.getRealTimeValues(this.getGeneralDevice());
      this.printStatusChart("rgb(145,145,145)");
      this.getDiaryActivePowerAnalyzer();
      this.getYearlyActivePowerAnalyzer();
    },
    methods: {
      // Llegir periode i potencia contractada per al header (dins al interval)
      getHeadCardsInfo() {
        axios.post(constants.ROOT_URL + '/api/v1/get_pow_contracted_per_period_and_current_period', {
          client_device: 'd',
          system_id: this.system.id
        }).then((response) => {
          this.period = response.data.period;
          this.pot_contracted = parseInt(response.data.pot_contracted);
        }, (response) => {
          console.log(response);
        });
      },
      getGeneralDevice() {
        var devices = this.devices;
        for (var i = 0; i < devices.length; i++) {
          if (devices[i].name.indexOf("General") > 0) {
            this.general = devices[i];
            this.getRealTimeValues();
            return;
          }
        }
      },
      getRealTimeValues() {
        axios.post(constants.ROOT_URL + '/api/v1/real_time_value', {
          system_id: this.system.id,
          client_device: 'd',
          vars: JSON.stringify([[this.general.id, "COSI", "API", "AE", "IE", "STATUS", "MDAPI", "MDI"]])
        }).then((response) => {
          this.cosi_general = Math.round(response.data[0].value * 100) / 100;
          this.api_general = Math.round(response.data[1].value * 10) / 10;
          this.ae_general = Math.round(response.data[2].value * 100) / 100;
          this.ie_general = Math.round(response.data[3].value * 100) / 100;
          this.status_analyzer = parseInt(response.data[4].value);
          this.mdapi_general = Math.round(response.data[5].value * 100) / 100;
          this.printPowerGraph();
          this.printCosiGraph();
          if(response.data[4].value==='-'){
            this.status_analyzer='S/D';
            this.printStatusChart("rgb(145,145,145)");
          }else {
            this.status_analyzer='OK';
            this.printStatusChart("rgb(0,255,0)");
          }
        }, (response) => {
          this.status_analyzer='ERROR';
          this.printStatusChart("rgb(255,0,0)");
          console.log(response);
        });
      },
      getDiaryActivePowerAnalyzer() {
        axios.post(constants.ROOT_URL + '/api/v1/stored_value', {
          system_id: this.system.id,
          vars: JSON.stringify([[this.general.id, "API"]]),
          client_device: 'd',
          date_range: dateRanges.currentDayDaterange()
        }).then((response) => {
          this.printActivePowerAnalyzer(dataTransforms.lineDataTransformCanvasJS(response.data, "line", ["P. Activa"]));
        }, (response) => {
          console.log(response.data);
        });
      },
      getYearlyActivePowerAnalyzer() {
        axios.post(constants.ROOT_URL + '/api/v1/stored_value', {
          system_id: this.system.id,
          vars: JSON.stringify([[this.general.id, "AEE"]]),
          client_device: 'd',
          date_range: dateRanges.currentYearDaterange()
        }).then((response) => {
          this.printYearEnergyAnalyzer(dataTransforms.dataTransYearlyFormCanvasJS(response.data, "column", ["P. Activa"]));
        }, (response) => {
          console.log(response.data);
        });
      },
      printStatusChart(color) {
        try {
        var opts = {
          angle: -0.50, // The span of the gauge arc
          lineWidth: 0.2, // The line thickness
          radiusScale: 0.80, // Relative radius
          pointer: {
            length: 0, // // Relative to gauge radius
            strokeWidth: 0 // The thickness
          },
          limitMax: false,     // If false, max value increases automatically if value > maxValue
          limitMin: false,     // If true, the min value of the gauge will be fixed
          strokeColor: '#E0E0E0',  // to see which ones work best for you
          generateGradient: true,
          highDpiSupport: true,     // High resolution support
          staticZones: [
            {strokeStyle: color, min: 0, max: 100, height: 1}
          ]
        };
        var target = document.getElementById('status-home-analyzer'); // your canvas element
        var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
        gauge.maxValue = 100; // set max gauge value
        gauge.setMinValue(0);  // Prefer setter over gauge.minValue = 0
        gauge.animationSpeed = 25; // set animation speed (32 is default value)
        gauge.set(100); // set actual value
        }catch (e){
          console.log("Catch");
        }
      },
      printPowerGraph() {
        // try {
        // var opts = {
        //   angle: -0.35, // The span of the gauge arc
        //   lineWidth: 0.2, // The line thickness
        //   radiusScale: 0.80, // Relative radius
        //   pointer: {
        //     length: 0.58, // // Relative to gauge radius
        //     strokeWidth: 0.029, // The thickness
        //     color: '#000000' // Fill color
        //   },
        //   limitMax: false,     // If false, max value increases automatically if value > maxValue
        //   limitMin: false,     // If true, the min value of the gauge will be fixed
        //   strokeColor: '#E0E0E0',  // to see which ones work best for you
        //   generateGradient: true,
        //   highDpiSupport: true,     // High resolution support
        //   // renderTicks is Optional
        //   renderTicks: {
        //     divisions: 4,
        //     divWidth: 1.1,
        //     divLength: 0.7,
        //     divColor: '#333333',
        //     subDivisions: 3,
        //     subLength: 0.5,
        //     subWidth: 0.6,
        //     subColor: '#666666'
        //   },
        //   staticLabels: {
        //     font: "12px sans-serif",  // Specifies font
        //     labels: [0, this.pot_contracted, this.pot_contracted * 1.05, this.pot_contracted * 1.5],  // Print labels at these values
        //     color: "#000000",  // Optional: Label text color
        //     fractionDigits: 0  // Optional: Numerical precision. 0=round off.
        //   },
        //   staticZones: [
        //     {strokeStyle: "rgb(0,255,0)", min: 0, max: this.pot_contracted, height: 1},
        //     {strokeStyle: "rgb(255,255,0)", min: this.pot_contracted + 0.00001, max: this.pot_contracted * 1.05, height: 1},
        //     {strokeStyle: "rgb(255,0,0)", min: this.pot_contracted * 1.05 + 0.00001, max: this.pot_contracted * 1.5, height: 1}
        //   ]
        // };
        // var target = document.getElementById('active-power-general'); // your canvas element
        // var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
        // gauge.maxValue = this.pot_contracted * 1.5; // set max gauge value
        // gauge.setMinValue(0);  // Prefer setter over gauge.minValue = 0
        // gauge.animationSpeed = 25; // set animation speed (32 is default value)
        // gauge.set(this.api_general); // set actual value
        // }catch (e){
        //   console.log("Catch");
        // }
        // try {
          var myConfig8 = {
            "type": "gauge",
            "scale-r": {
              "aperture": 280,
              "values": "0:"+(parseInt(this.pot_contracted*1.5))+":"+(parseInt(this.pot_contracted)/5),
              "center": {
                "size": 5,
                "background-color": "#ffff",
                "border-color": "none"
              },
              "markers": [ //Scale Markers
                { //Area Marker 1
                  "type": "area",
                  "range": [0, parseInt(this.pot_contracted)],
                  "offset-start": 0,
                  "offset-end": 0,
                  "background-color": "#00ff00",
                  "alpha": 0.7
                },
                { //Area Marker 2
                  "type": "area",
                  "range": [parseInt(this.pot_contracted), parseInt(this.pot_contracted)*1.05],
                  "offset-start": 0,
                  "offset-end": 0,
                  "background-color": "#FEFE00",
                  "alpha": 0.7
                },
                { //Area Marker 3
                  "type": "area",
                  "range": [parseInt(this.pot_contracted)*1.05, parseInt(this.pot_contracted)*1.4],
                  "offset-start": 0,
                  "offset-end": 0,
                  "background-color": "#DF0000",
                  "alpha": 0.7
                }
              ],
              "ring": {
                "size": 10,
              },
              // "labels": ["0.4", "0.7", "1", "-0.7", "-0.4"],  //Scale Labels
              "item": {  //Scale Label Styling
                "font-color": "black",
                "font-family": "Arial",
                "font-size": 12,
                "font-weight": "bold",   //or "normal"
                "font-style": "normal",   //or "italic"
                "offset-r": 0,
                "angle": "auto"
              }
            },
            "plot": {
              "csize": "5%",
              "size": "100%",
              "background-color": "#ffff"
            },
            "series": [
              {"values": [1.016]}
            ]
          };

          myConfig8.series[0].values[0] = this.api_general;

          zingchart.render({
            id: 'active-power-general',
            data: myConfig8,
            height: "100%",
            width: "100%"
          });
        // }catch (e) {
        //   console.log('Catch')
        // }
      },
      printActivePowerAnalyzer(data) {
        try {
        //Better to construct options first and then pass it as a parameter
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "HH:mm"
          },
          axisY: {
            suffix: "kW"
          },
          data: data  // random data
        };

        $("#active-power-general-diari").CanvasJSChart(options);
        }catch (e){
          console.log("Catch");
        }
      },
      printCosiGraph() {
        // try {
        // var opts = {
        //   angle: -0, // The span of the gauge arc
        //   lineWidth: 0.2, // The line thickness
        //   radiusScale: 0.55, // Relative radius
        //   pointer: {
        //     length: 0.58, // // Relative to gauge radius
        //     strokeWidth: 0.025, // The thickness
        //     color: '#000000' // Fill color
        //   },
        //   limitMax: false,     // If false, max value increases automatically if value > maxValue
        //   limitMin: false,     // If true, the min value of the gauge will be fixed
        //   strokeColor: '#E0E0E0',  // to see which ones work best for you
        //   generateGradient: true,
        //   highDpiSupport: true,     // High resolution support
        //   // renderTicks is Optional
        //   renderTicks: {
        //     divisions: 4,
        //     divWidth: 1.1,
        //     divLength: 0.7,
        //     divColor: '#333333',
        //     subDivisions: 3,
        //     subLength: 0.5,
        //     subWidth: 0.6,
        //     subColor: '#666666'
        //   },
        //   staticLabels: {
        //     font: "12px sans-serif",  // Specifies font
        //     labels: [-0.95, 0.95],  // Print labels at these values
        //     color: "#000000",  // Optional: Label text color
        //     fractionDigits: 2  // Optional: Numerical precision. 0=round off.
        //   },
        //   staticZones: [
        //     {strokeStyle: "rgb(0,255,0)", min: -1, max: -0.95, height: 1},
        //     {strokeStyle: "rgb(255,0,0)", min: -0.94, max: 0.94, height: 1},
        //     {strokeStyle: "rgb(0,255,0)", min: 0.95, max: 1, height: 1}
        //   ]
        // };
        // var target = document.getElementById('cosi-general'); // your canvas element
        // var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
        // gauge.maxValue = 1; // set max gauge value
        // gauge.setMinValue(-1);  // Prefer setter over gauge.minValue = 0
        // gauge.animationSpeed = 1; // set animation speed (32 is default value)
        // gauge.set(this.cosi_general); // set actual value
        // }catch (e){
        //   console.log("Catch");
        // }
        try {
          var myConfig8 = {
            "type": "gauge",
            "scale-r": {
              "aperture": 180,
              "values": "0:2:0.5",
              "center": {
                "size": 5,
                "background-color": "#ffff",
                "border-color": "none"
              },
              "markers": [ //Scale Markers
                { //Area Marker 1
                  "type": "area",
                  "range": [0, 0.91],
                  "offset-start": 0,
                  "offset-end": 0,
                  "background-color": "#DF0000",
                  "alpha": 0.7
                },
                { //Area Marker 2
                  "type": "area",
                  "range": [0.91, 1.09],
                  "offset-start": 0,
                  "offset-end": 0,
                  "background-color": "#00ff00",
                  "alpha": 0.7
                },
                { //Area Marker 3
                  "type": "area",
                  "range": [1.09, 2],
                  "offset-start": 0,
                  "offset-end": 0,
                  "background-color": "#d4ff00",
                  "alpha": 0.7
                }
              ],
              "ring": {
                "size": 10,
              },
              "labels": ["0.4", "0.7", "1", "-0.7", "-0.4"],  //Scale Labels
              "item": {  //Scale Label Styling
                "font-color": "black",
                "font-family": "Arial",
                "font-size": 12,
                "font-weight": "bold",   //or "normal"
                "font-style": "normal",   //or "italic"
                "offset-r": 0,
                "angle": "auto"
              }
            },
            "plot": {
              "csize": "5%",
              "size": "100%",
              "background-color": "#ffff"
            },
            "series": [
              {"values": [1.016]}
            ]
          };

          var graph_value = 1;
          if (this.cosi_general <= 1 && this.cosi_general > 0) {
            graph_value = ((5 / 3) * (this.cosi_general - 0.4));
          } else {
            graph_value = ((5 / 3) * (this.cosi_general + 1)) + 1;
          }

          console.log(graph_value);

          myConfig8.series[0].values[0] = graph_value;

          zingchart.render({
            id: 'cosi-general',
            data: myConfig8,
            height: "100%",
            width: "100%"
          });
        }catch (e) {
          console.log('Catch')
        }
      },
      printYearEnergyAnalyzer(data){
        try {
        //Better to construct options first and then pass it as a parameter
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "MM/YYYY"
          },
          axisY: {
            suffix: "kWh"
          },
          data: data  // random data
        };

        $("#ener-act-hom-analyzer").CanvasJSChart(options);
        }catch (e){
          console.log("Catch");
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /*Vue map container width*/
  #map {
    height: 300px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// AnalyzerStatus.vue?239d2c69